import { useCallback } from "react";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import { userApi } from "../api/apiClient";
import { CompanyAccount } from "../generated-api";

export const meState = atom<CompanyAccount | null>({
  key: "MeStore/meState",
  default: null,
});

export const useMyInfoState = (): ((data: CompanyAccount) => void) => {
  const setMyInfo = useSetRecoilState(meState);
  return useCallback(
    (data: CompanyAccount) => {
      setMyInfo(data);
    },
    [setMyInfo]
  );
};

export const useMeStore = (): CompanyAccount | null => useRecoilValue(meState);

export const useFetchMe = (): (() => Promise<void>) => {
  const setMe = useSetRecoilState(meState);

  return useCallback(async () => {
    const { data } = await userApi.userControllerMe();

    setMe(data);
  }, [setMe]);
};
